function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null);

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.1,
  cy: 2.8,
  r: 2.8,
  fill: "#fdc300"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.1,
  cy: 2.8,
  r: 2,
  fill: "#e30613"
});

function SvgIlluAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illu_about_svg__Tryb_izolacji",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 37.5 5.5",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IlRyeWJfaXpvbGFjamkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKCSB5PSIwcHgiIHZpZXdCb3g9IjAgMCAzNy41IDUuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzcuNSA1LjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMTYzRjU5O30KCS5zdDF7ZmlsbDojRTlENkI4O30KCS5zdDJ7ZmlsbDojRTJDNTlDO30KCS5zdDN7ZmlsbDojM0Q3QUE4O30KCS5zdDR7ZmlsbDojMTk0ODY2O30KCS5zdDV7ZmlsbDojM0JCNkQ1O30KCS5zdDZ7ZmlsbDojMzg2Njg1O30KCS5zdDd7ZmlsbDojNDk4M0FEO30KCS5zdDh7ZmlsbDojRjBDQTY3O30KCS5zdDl7ZmlsbDojRkZFMUNDO30KCS5zdDEwe2ZpbGw6I0Y0REE4MDt9Cgkuc3QxMXtmaWxsOiNBRUJEREM7fQoJLnN0MTJ7ZmlsbDojRDFEQkVBO30KCS5zdDEze2ZpbGw6I0ZGRkZGRjt9Cgkuc3QxNHtmaWxsOiNFMDlBM0Y7fQoJLnN0MTV7ZmlsbDojRDA3NzAyO30KCS5zdDE2e2ZpbGw6I0VDQjZBMDt9Cgkuc3QxN3tmaWxsOiNGRkM0QUQ7fQoJLnN0MTh7ZmlsbDojNjcxRTc1O30KCS5zdDE5e2ZpbGw6IzdBM0E4ODt9Cgkuc3QyMHtmaWxsOiM1MjI1NEE7fQoJLnN0MjF7ZmlsbDojRUVBRENEO30KCS5zdDIye2ZpbGw6I0ZEQzMwMDt9Cgkuc3QyM3tmaWxsOiNFMzA2MTM7fQoJLnN0MjR7ZmlsbDojODA4MDgwO30KCS5zdDI1e2ZpbGw6IzMxMzEzMTt9Cgkuc3QyNntmaWxsOiM3RDdEN0Q7fQo8L3N0eWxlPgo8Y2lyY2xlIGNsYXNzPSJzdDIyIiBjeD0iMy4xIiBjeT0iMi44IiByPSIyLjgiLz4KPGNpcmNsZSBjbGFzcz0ic3QyMyIgY3g9IjM1LjEiIGN5PSIyLjgiIHI9IjIiLz4KPC9zdmc+Cg==";
export { SvgIlluAbout as ReactComponent };